import {
    useSkyNetRoutes,
} from 'app/SkyNetRoutes'
import {
    CommonRoutes,
} from 'app/enums/common.enums'
import useAccountManagementRoutes from 'app/SkyNetRoutes/hooks/useAccountManagementRoutes'
import CQuoteCreateSelectMethod from './CQuoteCreateSelectMethod'

export default function CQuoteCreateSelectMethodRouter() {
    const {
        CQuotes,
    } = useAccountManagementRoutes()

    return useSkyNetRoutes({
        routes: [{
            path: CommonRoutes.Slash.concat(CQuotes.Create.stringParams),
            element: <CQuoteCreateSelectMethod />,
        }],
    })
}
